import "./styles.scss";

import classnames from "classnames";
import { ReactComponent as ArrowIcon } from "assets/icons/new/forward-arrow.svg";

const mainClass = "dropdown-button";

const DropdownButton = ({ active, component, variant }) => {
  return (
    <div
      className={classnames(mainClass, {
        [`${mainClass}--active`]: active,
        [`${mainClass}--${variant}`]: !!variant,
      })}
    >
      {component}
      <ArrowIcon />
    </div>
  );
};

export default DropdownButton;
